module.exports = __webpack_public_path__ + "static/product-description-on-mobile-f17bf371bdcd98cb2991a83e0e545a81.png";